import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReportType } from "app/pages/reports-and-analytics/types/client";
import { DateTime } from "luxon";
import { TransportationMode } from "pages/shipper/pages/quotes/types/TransportationMode";
import usableActions from "utils/store/usableActions";

import brokerInsightsApi from "../api/brokerInsightsApi";

export type BrokerInsightsIndexFilterState = {
  mode: TransportationMode;
  searchQuery: string;
  fromDate?: string;
  toDate?: string;
  isFilterDialogOpen: boolean;
  reportTypes?: ReportType[];
  selectedReport?: ReportType;
  lastRefreshedAt?: string;
};

const initialState: BrokerInsightsIndexFilterState = {
  mode: TransportationMode.FTL,
  searchQuery: "",
  fromDate: undefined,
  toDate: undefined,
  isFilterDialogOpen: false,
};

const slice = createSlice({
  name: "brokerInsightsIndexFilterSlice",
  initialState,
  reducers: {
    setFilterState: (state, action: PayloadAction<Partial<BrokerInsightsIndexFilterState>>) => {
      return { ...state, ...action.payload };
    },
  },
  extraReducers(builder) {
    builder.addMatcher(brokerInsightsApi.endpoints.getBrokerReportTypeList.matchFulfilled, (state, action) => {
      const reportTypes = action.payload.reports;

      state.reportTypes = reportTypes;
      state.lastRefreshedAt = DateTime.fromMillis(action.meta.fulfilledTimeStamp).toLocaleString(
        DateTime.TIME_WITH_SECONDS
      );

      if (state.selectedReport === undefined) {
        state.selectedReport = reportTypes[0];
      }
    });
  },
});

export const { useSetFilterState } = usableActions(slice.actions);
export default slice;
